export default __webpack_public_path__ + "static/lefafa_2_5-b8e8ec3701e261588583ccad878e4b43.webp";